import React from "react";
import "./Title.css";

const Title = props => <h1 className="title">Clicky Fishy Game</h1>;

export default Title;